import Store from '@/redux/store';
import type { AnyAction } from 'redux';
import { useSelector } from 'react-redux';
import type { AppSelector } from '@/redux/types';

// Global Application State Selector e.g.:
// const userEmail = useAppSelector(state => state.user.email);
export const useAppSelector: AppSelector = useSelector;

export default Store as typeof Store & {
  dispatch: (state: unknown) => AnyAction;
};
